// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Переміщено ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'Дію ' + p['label'] + ' виконано',
  accButtonProgressStatus: (p: { label: string }) => 'Дія ' + p['label'] + ' у процесі виконання',
  accColorPalette: () => 'Палітра кольорів',
  accColorSwatch: () => 'Палітра кольорів',
  accCommandKey: () => 'Команда',
  accContextMenuLabel: () => 'дії',
  accControlKey: () => 'Закрити',
  accPositionAfter: () => 'після',
  accPositionBefore: () => 'до',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Натисніть та утримуйте клавіші ' +
    p['keyPressed'] +
    ' і Shift, а потім використовуйте клавіші зі стрілками, щоб змінити порядок.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Введіть таку дату завершення: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Введіть такий місяць і рік: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Мітка',
  chart_labelGroup: () => 'Група',
  chart_labelSeries: () => 'Серія',
  chart_labelValue: () => 'Значення',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Виберіть значення.',
  checkbox_helpForCheckbox: () => 'Довідка для прапорця',
  checkbox_requiredMessageDetail: () => 'Виберіть значення.',
  checkbox_selected: () => 'Прапорець установлено',
  checkbox_unselected: () => 'Прапорець не встановлено',
  close: () => 'Закрити',
  collection_apply: () => 'Застосувати',
  collection_cancel: () => 'Скасувати',
  collection_loaded: () => 'Завантажено',
  collection_loading: () => 'Завантаження',
  collection_noData: () => 'Немає даних для відображення.',
  collection_pixels: () => 'пкс',
  collection_resizeColumnDialog: () => 'Змінити розмір стовпця',
  collection_resizeColumnMenu: () => 'Змінити розмір стовпця...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Введіть число від ' + p['MIN'] + ' до ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Вибрати всі рядки',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Вибрати рядок ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'За зростанням',
  collection_sortColumnMenu: () => 'Сортувати стовпець',
  collection_sortDescendingSubMenu: () => 'За спаданням',
  collection_sortDisabled: () => 'Без можливості сортування',
  collection_sortEnabled: () => 'З можливістю сортування',
  collection_width: () => 'Ширина',
  colorPicker_label: () => 'Палітра кольорів',
  confirmation: () => 'Підтвердження',
  datePicker_currentDate: () => 'Поточна дата',
  datePicker_goToToday: () => 'Перейти до поточного дня',
  datePicker_label: () => 'Вибір дати',
  datePicker_month: () => 'Місяць',
  datePicker_months: () => 'Місяці',
  datePicker_next: () => 'Далі',
  datePicker_nextDecade: () => 'Наступне десятиліття',
  datePicker_nextMonth: () => 'Наступний місяць',
  datePicker_prev: () => 'Назад',
  datePicker_prevDecade: () => 'Попереднє десятиліття',
  datePicker_prevMonth: () => 'Попередній місяць',
  datePicker_restricted: () => 'Обмежено',
  datePicker_selected: () => 'Вибрано',
  datePicker_today: () => 'Сьогодні',
  datePicker_weekNum: (p: { NUM: string }) => 'Тиждень ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Номер тижня',
  datePicker_year: () => 'Рік',
  datePicker_years: () => 'Роки',
  diagram_promotedLink: () => '1 посилання',
  diagram_promotedLinkAriaDesc: () => 'Непряме',
  diagram_promotedLinks: (p: { num_links: string }) => 'Посилань: ' + p['num_links'],
  error: () => 'Помилка',
  expandableList_expandCollapseInstructionText: () =>
    'Щоб розгорнути або згорнути, використовуйте клавіші зі стрілками',
  expandableList_groupCollapse: () => 'Згорнуто',
  expandableList_groupExpand: () => 'Розгорнуто',
  filePicker_addFiles: () => 'Додати файли',
  filePicker_dropzonePrimaryText: () => 'Перетягнути',
  filePicker_dropzoneSecondaryText: () => 'Виберіть файл або перетягніть його сюди',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Виберіть файли або перетягніть їх сюди',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Неможливо передати файли типів ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Передайте один файл за раз',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Неможливо передати файл типу ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'невідомо',
  formControl_clear: () => 'Очистити',
  formControl_day: () => 'День',
  formControl_empty_segment: () => 'Порожній',
  formControl_helpAvailable: () => 'Довідка доступна',
  formControl_hide: () => 'Приховати',
  formControl_hour: () => 'год',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Ви досягли обмеження в ' +
    ((
      {
        one: new Intl.NumberFormat('uk').format(p['CHARACTER_LIMIT']) + '-символ',
        few: new Intl.NumberFormat('uk').format(p['CHARACTER_LIMIT']) + '-символи',
        many: new Intl.NumberFormat('uk').format(p['CHARACTER_LIMIT']) + '-символів'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('uk').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('uk').format(p['CHARACTER_LIMIT']) + '-символа') +
    '.',
  formControl_loading: () => 'Завантаження',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Можна ввести символів: не більше ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Максимальну довжину (' + p['MAX_LENGTH'] + ') перевищено.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Залишилася така кількість символів: ' + p['CHARACTER_COUNT'] + '.',
  formControl_millisecond: () => 'мс',
  formControl_minute: () => 'хв',
  formControl_month: () => 'Місяць',
  formControl_readOnly: () => 'Лише для читання',
  formControl_requiredMessageDetail: () => 'Введіть значення.',
  formControl_second: () => 'с',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Виберіть значення (' + p['n'] + ').',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Ви досягли ліміту вибору (' + p['max'] + ').',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Виберіть кількість значень у діапазоні від ' + p['min'] + ' до ' + p['max'] + '.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Виберіть принаймні таку кількість значень: ' + p['min'] + '.',
  formControl_show: () => 'Показати',
  formControl_year: () => 'Рік',
  gantt_labelDate: () => 'Дата',
  gantt_labelEnd: () => 'Кінець',
  gantt_labelLabel: () => 'Мітка',
  gantt_labelRow: () => 'Рядок',
  gantt_labelStart: () => 'Початок',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Не знайдено відповідних розділів.',
  indexer_keyboardInstructionText: () => 'Натисніть клавішу Enter, щоб вибрати значення.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Від ' + p['FROM_SECTION'] + ' до ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Двічі торкніться й утримайте, щоб увійти в режим жестів, а потім перетягніть угору або вниз, щоб змінити значення.',
  info: () => 'Відомості',
  inputColor_selectColor: () => 'Вибір кольору',
  inputDateMask_date_cleared: () => 'Дата зарахування',
  inputDateMask_dayPlaceholder: () => 'дд',
  inputDateMask_empty_segment: () => 'Порожній',
  inputDateMask_monthPlaceholder: () => 'мм',
  inputDateMask_yearPlaceholder: () => 'рррр',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Введіть дату, що передує даті ' + p['max'] + ' або збігається з нею.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Введіть дату, що не передує ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Введіть доступну дату.',
  inputDatePicker_instruction: () => 'Натисніть клавішу Tab, щоб отримати доступ до календаря.',
  inputDatePicker_selectDate: () => 'Вибрати дату',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Введіть місяць або рік, які настають не пізніше ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Введіть місяць або рік, які настають не раніше ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Введіть число.',
  inputNumber_decrease: () => 'Зменшення',
  inputNumber_increase: () => 'Збільшення',
  inputPassword_hidden: () => 'Пароль приховано',
  inputPassword_hide: () => 'Приховати пароль',
  inputPassword_show: () => 'Показати пароль',
  inputSensitiveText_hidden: () => 'Конфіденційний текст приховано',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Введіть час, що дорівнює ' + p['max'] + ' або настає раніше.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Введіть час, що дорівнює ' + p['min'] + ' або настає пізніше.',
  inputTimeMask_time_cleared: () => 'Час очищено',
  labelNone: () => 'Відсутнє',
  list_msgFetchCompleted: () => 'Завантажено',
  list_msgFetchingData: () => 'Завантаження',
  list_suggestion: () => 'Пропозиція',
  menu_stateLoading: () => 'Завантаження',
  messageToast_allMessagesClosed: () => 'Усі спливні повідомлення закрито.',
  message_close: () => 'Закрити',
  message_confirmation: () => 'Виконано',
  message_error: () => 'Помилка',
  message_info: () => 'Відомості',
  message_navigationFromMessagesRegion: () =>
    'Вхід в область повідомлень. Натисніть F6, щоб перейти.',
  message_navigationToMessagesRegion: () =>
    'В області повідомлень наявні нові повідомлення. Натисніть клавішу F6, щоб перейти до них.',
  message_navigationToTouch: () => 'В області повідомлень наявні нові повідомлення.',
  message_warning: () => 'Попередження',
  noData_message: () => 'Немає позицій для відображення',
  overflowItemLabel: () => 'Більше вкладок',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Двічі торкніться, щоб закрити відкрите спливаюче вікно.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Вхід у спливаюче вікно. Натисніть клавішу F6 для переходу між спливаючим вікном і відповідним елементом керування.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Спливаюче вікно відкрито. Натисніть клавішу F6 для переходу між спливаючим вікном і відповідним елементом керування.',
  progressIndeterminate: () => 'Триває',
  radioButton_checked: () => 'Перемикач увімкнено',
  radioButton_selected: () => 'Перемикач вибрано',
  radioButton_unchecked: () => 'Перемикач не ввімкнено',
  radioButton_unselected: () => 'Перемикач не вибрано',
  radio_helpForRadio: () => 'Довідка для перемикача',
  radio_requiredMessageDetail: () => 'Виберіть значення.',
  selectMultiple_apply: () => 'Застосувати',
  selectMultiple_back: () => 'Назад',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Використовуйте клавіші зі стрілками вліво та вправо, щоб виділити вибрані значення.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Натисніть клавішу Backspace або Delete, щоб вилучити вибране значення.',
  selectMultiple_selectedValues: () => 'Вибрані значення',
  selectMultiple_showSelectedValues: () => 'Показувати лише вибрані значення.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Вибрано таку кількість значень: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Додати до списку',
  select_addToListAvailable: () => 'Додати до доступного списку',
  select_closeDropdown: () => 'Натисніть клавішу Escape, щоб закрити.',
  select_moreSearchOptions: () => 'Більше параметрів пошуку',
  select_moreSearchOptionsAvailable: () => 'Більше доступних параметрів пошуку',
  select_noMatchesFound: () => 'Збігів не знайдено.',
  select_oneMatchFound: () => 'Знайдено один збіг',
  select_requiredMessageDetail: () => 'Виберіть значення.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Знайдено таку кількість збігів: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Знайдено ' + p['TOTAL_SIZE'] + ' або більше збігів',
  selectorAll_deselectAll: () => 'Скасувати вибір усього',
  selectorAll_selectAll: () => 'Вибрати все',
  selector_selected: () => 'Прапорець установлено',
  selector_unselected: () => 'Прапорець не встановлено',
  sheet_close: () => 'Закрити',
  switch_off: () => 'Вимк.',
  switch_on: () => 'Увімкнено',
  tabBarNavigationList_removeCueText: () => 'Можна вилучити',
  tabBar_tabContainsErrors: () => 'Містить помилки',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => '"' + p['itemKey'] + '" вилучено',
  tabbar_labelContextMenu: () => 'містить контекстне меню',
  tabbar_labelMoveLeft: () => 'Перемістити ліворуч',
  tabbar_labelMoveRight: () => 'Перемістити праворуч',
  tabbar_labelRemove: () => 'Вилучити',
  timeComponent_tooltipZoomIn: () => 'Збільшення',
  timeComponent_tooltipZoomOut: () => 'Зменшення',
  timeConverter_parseError: () => 'Введіть час завершення.',
  train_current: () => 'Поточний',
  train_message_type: () => 'Тип повідомлень',
  train_not_visited: () => 'Непереглянутий',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Крок ' + p['currentStep'] + ' із ' + p['numberOfSteps'],
  train_visited: () => 'Переглянутий',
  userAssistance_learnMore: () => 'Додаткові відомості',
  userAssistance_required: () => "Обов'язково",
  vis_clearSelection: () => 'Скасувати вибір',
  vis_drillable: () => 'З можливістю деталізації',
  vis_invalidData: () => 'Неприпустимі дані',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' з ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Вибрати рухомий рядок',
  vis_marqueeZoomTooltip: () => 'Змінити масштаб рухомого рядка',
  vis_noData: () => 'Немає даних для відображення',
  vis_panTooltip: () => 'Панорамування',
  vis_stateCollapsed: () => 'Згорнуто',
  vis_stateExpanded: () => 'Розгорнуто',
  vis_stateLoaded: () => 'Завантажено',
  vis_stateLoading: () => 'Завантаження',
  vis_stateSelected: () => 'Вибрано',
  vis_stateUnselected: () => 'Не вибрано',
  warn: () => 'Попередження'
};
export default bundle;
